import { useActiveAccessToken } from "./useActiveAccessToken";

/**
 * Kept as a thin alias so existing call sites don't need updates.
 * New code should prefer useActiveAccessToken directly.
 */
export function useMember360Token() {
  return useActiveAccessToken();
}
